/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Previous_ButtonInputs */

const en_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const fr_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedent`)
};

const de_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige`)
};

const it_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedente`)
};

const ru_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий`)
};

const es_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const zh_cn2_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以前的`)
};

const ja_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の`)
};

const hi_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले का`)
};

const pt_pt2_error_nav_previous_button = /** @type {(inputs: Error_Nav_Previous_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Error_Nav_Previous_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_previous_button = /** @type {((inputs?: Error_Nav_Previous_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Previous_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_previous_button(inputs)
	if (locale === "de") return de_error_nav_previous_button(inputs)
	if (locale === "it") return it_error_nav_previous_button(inputs)
	if (locale === "ru") return ru_error_nav_previous_button(inputs)
	if (locale === "es") return es_error_nav_previous_button(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_previous_button(inputs)
	if (locale === "ja") return ja_error_nav_previous_button(inputs)
	if (locale === "hi") return hi_error_nav_previous_button(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_previous_button(inputs)
	return en_error_nav_previous_button(inputs)
});